import { type FC } from 'react';
import styled from 'styled-components';

import { useUserLocale } from '@/i18n/hooks';

interface Props {
  percentage: number;
}

/** Renders a styled localized text for displaying a percentage.
 * @param {number} percentage - The percentage to display.
 */
export const EsgPercentageText: FC<Props> = ({ percentage }) => {
  const locale = useUserLocale();

  return (
    <StyledSpan className="font-body-demibold">
      {`${percentage.toLocaleString(locale)}%`}
    </StyledSpan>
  );
};

const StyledSpan = styled.span`
  font-size: 32px;
  margin: 24px 0;
`;
